import { useEffect, useState } from 'react'
import { useStore } from '../core/store'
import { rangeToA1, ref } from '../core/a1'

export default function FormulaBar() {
  const wb = useStore((s) => s.wb)
  const sel = useStore((s) => s.sel)
  const version = useStore((s) => s.version)
  const setCellsRaw = useStore((s) => s.setCellsRaw)
  const select = useStore((s) => s.select)
  const selRange = useStore((s) => s.selRange)

  const sheet = wb.sheets.find((s) => s.id === wb.activeSheetId) ?? wb.sheets[0]
  const key = ref(sel.focus.row, sel.focus.col)
  const cell = sheet.cells[key]
  const source = cell?.f ?? (cell?.v === null || cell?.v === undefined ? '' : String(cell.v))

  const [draft, setDraft] = useState(source)
  const [dirty, setDirty] = useState(false)

  useEffect(() => {
    setDraft(source)
    setDirty(false)
  }, [key, version, sheet.id]) // eslint-disable-line react-hooks/exhaustive-deps

  const r = selRange()
  const label = r.r1 === r.r2 && r.c1 === r.c2 ? key : `${rangeToA1(r)}`

  const commit = () => {
    if (!dirty) return
    setCellsRaw(sheet.id, [{ row: sel.focus.row, col: sel.focus.col, input: draft }], `${key} 입력`)
    setDirty(false)
    select({ row: Math.min(sheet.rows, sel.focus.row + 1), col: sel.focus.col })
  }

  return (
    <div className="formula-bar">
      <div className="formula-name" title="선택 영역">
        {label}
      </div>
      <div className="formula-fx">fx</div>
      <input
        className="formula-input"
        value={draft}
        placeholder="값 또는 =수식"
        onChange={(e) => {
          setDraft(e.target.value)
          setDirty(true)
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault()
            commit()
          } else if (e.key === 'Escape') {
            setDraft(source)
            setDirty(false)
            e.currentTarget.blur()
          }
        }}
        onBlur={commit}
      />
    </div>
  )
}
